<template>
  <div>
    <button 
      @click="showModal = true" 
      class="footer-action-button"
    >
      我要吐槽
    </button>

    <div 
      v-if="showModal" 
      @click.self="closeModal"
      class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
    >
      <div class="bg-white py-2 px-6 md:py-4 md:px-6 rounded-lg w-full max-w-md mx-4">
        <h2 class="text-lg md:text-xl font-bold mb-4 text-gray-800">我要吐槽</h2>
        <form @submit.prevent="submitFeedback" class="m-0">
          <div class="mb-4">
            <textarea
              id="feedback"
              v-model="form.feedback"
              required
              class="feedback-textarea"
              rows="4"
            ></textarea>
            <p class="text-sm text-gray-500 mt-1">您的意见我们尽快处理(通常24h内), 如果意见被采纳, 奖励双倍消耗积分</p>
          </div>
          
          <div class="flex justify-end gap-3 md:gap-4 mt-4">
            <button 
              type="button" 
              @click="closeModal"
              class="modal-button modal-button-secondary"
            >
              取消
            </button>
            <button 
              type="submit"
              class="modal-button modal-button-primary"
            >
              提交
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      showModal: false,
      form: {
        feedback: '',
        email: ''
      }
    }
  },
  methods: {
    closeModal() {
      this.showModal = false
    },
    async submitFeedback() {
      try {
        // Get user email from store or use feedback as both email and message
        const userEmail = this.$store?.state?.auth?.user?.email || '';
        
        // Get current URL
        const currentUrl = window.location.href;
        
        await axios.post('/api/feedback', {
          email: userEmail,
          message: this.form.feedback,
          url: currentUrl
        }, {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("access_token")}`,
          }
        });
        
        this.$message.success('反馈提交成功！');
        this.closeModal();
        this.form.feedback = '';
      } catch (error) {
        console.error('Feedback error:', error);
        this.$message.error(error.response?.data?.error || '提交反馈失败');
      }
    }
  }
}
</script>

<style scoped>
.footer-action-button {
  appearance: none;
  border: 1px solid rgba(148, 163, 184, 0.24);
  background: rgba(15, 23, 42, 0.72);
  color: #f8fafc;
  padding: 0.5rem 0.85rem;
  border-radius: 999px;
  cursor: pointer;
  font-size: 0.88rem;
  font-weight: 600;
  letter-spacing: 0.01em;
  line-height: 1;
  transition: transform 0.18s ease, background-color 0.18s ease, border-color 0.18s ease, box-shadow 0.18s ease;
  box-shadow: 0 10px 24px rgba(15, 23, 42, 0.12);
}

.footer-action-button:hover {
  transform: translateY(-1px);
  background: rgba(30, 41, 59, 0.92);
  border-color: rgba(148, 163, 184, 0.38);
  box-shadow: 0 14px 28px rgba(15, 23, 42, 0.16);
}

.footer-action-button:focus-visible {
  outline: 2px solid rgba(96, 165, 250, 0.9);
  outline-offset: 2px;
}

.feedback-textarea {
  width: 100%;
  padding: 0.6rem 0.75rem;
  border: 1px solid #dbe3ee;
  border-radius: 0.75rem;
  color: #1f2937;
  font-size: 0.95rem;
  line-height: 1.5;
  resize: vertical;
  transition: border-color 0.18s ease, box-shadow 0.18s ease;
}

.feedback-textarea:focus {
  outline: none;
  border-color: #94a3b8;
  box-shadow: 0 0 0 3px rgba(148, 163, 184, 0.18);
}

.modal-button {
  padding: 0.45rem 0.8rem;
  border-radius: 999px;
  font-size: 0.88rem;
  font-weight: 600;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.18s ease, background-color 0.18s ease, border-color 0.18s ease;
}

.modal-button:hover {
  transform: translateY(-1px);
}

.modal-button-secondary {
  background: #fff;
  color: #334155;
  border: 1px solid #cbd5e1;
}

.modal-button-secondary:hover {
  background: #f8fafc;
}

.modal-button-primary {
  background: linear-gradient(135deg, #334155 0%, #0f172a 100%);
  color: #fff;
  border: 1px solid rgba(15, 23, 42, 0.8);
}

.modal-button-primary:hover {
  background: linear-gradient(135deg, #475569 0%, #1e293b 100%);
}
</style>
